<div class="modal-backdrop" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Close Button -->
    <button class="modal-close" (click)="closeModal()" type="button">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L4 12M4 4L12 12" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <!-- Shield Icon -->
    <div class="modal-icon">
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M40 10L15 20V40C15 55.5 25 68.5 40 75C55 68.5 65 55.5 65 40V20L40 10Z" fill="#3B82F6" stroke="#2563EB" stroke-width="2"/>
        <path d="M30 40L36 46L50 32" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <!-- Message -->
    <div class="modal-message">
      {{ message }}
    </div>

    <!-- Action Buttons -->
    <div class="modal-actions">
      <button class="btn-cancel" (click)="onCancel()" type="button">
        {{ cancelText }}
      </button>
      <button class="btn-confirm" (click)="onConfirm()" type="button">
        {{ confirmText }}
      </button>
    </div>
  </div>
</div>

